module.exports = __webpack_public_path__ + "static/02-5f86b66e45d4335e037b94cd5fa786e5.jpg";